import axios from "axios";
import { apiPath, API_URL } from "./apiPath";
import authHeader from "./authHeader";

const getScheduledInterviewApi = (props) => {
  return axios
    .post(API_URL + apiPath.getScheduledInterview, props, authHeader())
    .then((response) => {
      return response.data;
    });
};

const getInterviewTimeSlotsApi = (props) => {
  return axios
    .post(API_URL + apiPath.getInterviewTimeSlots, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const confirmScheduledInterviewApi = (props) => {
  return axios
    .post(API_URL + apiPath.confirmScheduledInterview, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getInterviewDetailsApi = (props) => {
  return axios
    .post(API_URL + apiPath.getInterviewDetails, props, authHeader())
    .then((response) => {
      return response.data;
    });
};

const rescheduleInterviewApi = (props) => {
  return axios
    .post(API_URL + apiPath.rescheduleInterview, props, authHeader())
    .then((response) => {
      return response.data;
    });
};

const cancelInterviewApi = (props) => {
  return axios
    .post(API_URL + apiPath.cancelInterview, props, authHeader())
    .then((response) => {
      return response.data;
    });
};
const declineInterviewScheduleApi = (props) => {
  return axios
    .post(API_URL + apiPath.declineInterviewSchedule, props, authHeader())
    .then((response) => {
      return response.data;
    });
};

const interviewDropdownAPI = {
  getScheduledInterviewApi,
  getInterviewTimeSlotsApi,
  confirmScheduledInterviewApi,
  getInterviewDetailsApi,
  rescheduleInterviewApi,
  cancelInterviewApi,
  declineInterviewScheduleApi,
};
export default interviewDropdownAPI;
